module.exports = __webpack_public_path__ + "static/media/percentile-tooltip-1.c4dd0bbc.png";